module.exports = __webpack_public_path__ + "img/imiwin-support.4195cfe5.webp";